import { createSlice } from '@reduxjs/toolkit';
import storage from "redux-persist/lib/storage"
import { globals } from '../Components/Globals/Globals';

const initialState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      console.log("loginSuccess::action.payload->", action.payload);

      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = true;

      if (globals.parameters.debugging){
        console.log("loginSuccess::state->", state)
      }
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.error = null;
      storage.removeItem('persist:root')
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } = authSlice.actions;

export default authSlice.reducer;